// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-wrapper{background-color:hsla(0,0%,100%,.5);left:0;right:0;top:0;bottom:0}", ""]);
// Exports
module.exports = exports;
